import { useEffect, useState } from "react";
import { TailSpin } from "react-loader-spinner";
import { useNavigate } from "react-router-dom";

import handleGetFullEmpName from "../../libs/getFullName";
import { formatDate } from "../../libs/generalFunctions";

import useDepartmentUsers from "../../customHooks/useDepartmentUsers";

import SearchCompGeneral from "../../components/SearchCompGeneral/SearchCompGeneral";
import PaginationComp from "../../components/PaginationComp/PaginationComp";

import "./DepartmentEmpVecation.scss";

function DepartmentEmpVecation() {
  const navigate = useNavigate();

  const {
    fetchEmps,
    empsArr,
    loadingResult,
    currentPage,
    totalPages,
    error,
  } = useDepartmentUsers();

  // ==== State ====
  const [searchValue, setSearchValue] =
    useState("");

  // ==== Pagination ====
  const handelFetchDataForPagnation = (
    page
  ) => {
    fetchEmps(page, searchValue);
  };

  // ==== Vacation Request ====
  const handelReqForVacation = (
    e,
    job_id,
    emp_name
  ) => {
    e.preventDefault();

    navigate(
      "/emp/vaca_req_by_manager",
      {
        state: {
          job_id,
          emp_name,
        },
      }
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    fetchEmps(1, searchValue);
  };

  // ==== Initial Load ====
  useEffect(() => {
    fetchEmps(1, searchValue);
  }, []);

  return (
    <div className="departmentEmpVecation_full_page">
      <div className="departmentEmpVecation_container">
        <div className="departmentEmpVecation_container_top">
          <span>موظفي القسم - طلب إجازة</span>
        </div>

        <SearchCompGeneral
          handleSubmit={handleSubmit}
          loadingResult={loadingResult}
          setSearchValue={setSearchValue}
          searchValue={searchValue}
          searchBtnColorActive={
            "rgba(52,144,220,255)"
          }
          searchBtnColorInActive={
            "rgba(50, 148, 194, 0.685)"
          }
          btnTextColor={"white"}
          isDisabled={
            loadingResult ? true : false
          }
        />

        {loadingResult ? (
          <div className="spinner_getData">
            <TailSpin
              visible={true}
              height="40"
              width="40"
              color="rgb(246,229,56)"
              ariaLabel="tail-spin-loading"
              radius="1"
            />
          </div>
        ) : (
          <>
            <div className="departmentEmpVecation_container_tableShow">
              <table className="VacationsForTodayAccepted_table">
                <thead>
                  <tr className="VacationsForTodayAccepted_header_row_table">
                    <th>تقديم إجازة</th>
                    <th>رقم الموبايل</th>
                    <th>تاريخ المباشرة</th>
                    <th>الاسم</th>
                    <th>الرقم الوظيفي</th>
                  </tr>
                </thead>

                <tbody>
                  {empsArr?.map((obj) => (
                    <tr key={obj.job_id}>
                      <td dir="rtl">
                        <button
                          className="exist_per_btn"
                          dir="rtl"
                          onClick={(e) =>
                            handelReqForVacation(
                              e,
                              obj.job_id,
                              handleGetFullEmpName(
                                obj
                              )
                            )
                          }
                        >
                          تقديم
                        </button>
                      </td>

                      <td dir="rtl">
                        {obj.mobile}
                      </td>

                      <td dir="rtl">
                        {obj?.hiring_date &&
                          formatDate(
                            obj.hiring_date
                          )}
                      </td>

                      <td dir="rtl">
                        {handleGetFullEmpName(
                          obj
                        )}
                      </td>

                      <td dir="rtl">
                        {obj.job_id}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              {error && (
                <span
                  style={{
                    color: "red",
                    margin: "1rem 0rem",
                  }}
                >
                  {error}
                  <span
                    style={{
                      color: "red",
                    }}
                  >
                    *
                  </span>
                </span>
              )}
            </div>
          </>
        )}

        {!loadingResult && (
          <PaginationComp
            currentPage={currentPage}
            totalPages={totalPages}
            handleGetData={
              handelFetchDataForPagnation
            }
          />
        )}
      </div>
    </div>
  );
}

export default DepartmentEmpVecation;